import styled, { css } from 'styled-components'

import { isDesktop } from 'utils/device'

export const Video = styled.video`
    width: 100%;
    height: 100%;
    z-index: 6;
    object-fit: ${props =>
        props.isTeacherIdentity && !isDesktop ? 'contain' : 'cover'};
    ${props =>
        props.isScreenShare
            ? css`
                  border-radius: inherit;
                  object-fit: unset;
                  ${isDesktop &&
                      css`
                          width: unset;
                          height: unset;
                          max-height: 80vh;
                          max-width: 100%;

                          @media screen and (max-height: 600px) {
                              max-height: 70vh;
                          }
                      `}
              `
            : props.isTeacherIdentity
            ? css`
                  border-radius: 10px;
              `
            : css`
                  border-radius: 50%;
              `}

    ${props =>
        /*It turns out that there is a "bug" in the safari versions of webkit. 
        When a 3d css animation is playing, the original z-indexes are lost. 
        Instead, it seems like the animating pieces are put into a separate z-index "group" 
        that is separate from the rest of the z-indexes of the DOM.
        To preserve it we add -webkit-transform: translate3d(0, 0, 0);*/

        // putting scale value for self mirroring, only for local video tracks

        props.shouldRotate &&
        css`
            transform: rotateY(180deg) scaleX(-1);
            -webkit-transform: translate3d(0, 0, 0) scaleX(-1);
        `}
`
